(function (){
    'use strict';

    angular
        .module('expenses', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'angular.morris',
            'angular-flot',
            'daterangepicker'
        ]);
})();